import { render, staticRenderFns } from "./ChatbotWidget.vue?vue&type=template&id=4d06f6e0&"
import script from "./ChatbotWidget.vue?vue&type=script&lang=js&"
export * from "./ChatbotWidget.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports